export const API_GET_ALL_DOCUMENT_TYPE = "API_GET_ALL_DOCUMENT_TYPE";
export const API_GET_ALL_DOCUMENT_TYPE_SUCCESS = "API_GET_ALL_DOCUMENT_TYPE_SUCCESS";
export const API_GET_ALL_DOCUMENT_TYPE_FAIL = "API_GET_ALL_DOCUMENT_TYPE_FAIL";

export const API_GET_DOCUMENT_TYPE_BY_NAME = "API_GET_DOCUMENT_TYPE_BY_NAME";
export const API_GET_DOCUMENT_TYPE_BY_NAME_FAIL = "API_GET_DOCUMENT_TYPE_BY_NAME_FAIL";
export const API_GET_DOCUMENT_TYPE_BY_NAME_SUCCESS = "API_GET_DOCUMENT_TYPE_BY_NAME_SUCCESS";

export const API_ADMIN_GET_ALL_DOCUMENT_TYPE = "API_ADMIN_GET_ALL_DOCUMENT_TYPE";
export const API_ADMIN_GET_ALL_DOCUMENT_TYPE_SUCCESS = "API_ADMIN_GET_ALL_DOCUMENT_TYPE_SUCCESS";
export const API_ADMIN_GET_ALL_DOCUMENT_TYPE_FAIL = "API_ADMIN_GET_ALL_DOCUMENT_TYPE_FAIL";

export const API_ADMIN_GET_DOCUMENT_TYPE = "API_ADMIN_GET_DOCUMENT_TYPE";
export const API_ADMIN_GET_DOCUMENT_TYPE_SUCCESS = "API_ADMIN_GET_DOCUMENT_TYPE_SUCCESS";
export const API_ADMIN_GET_DOCUMENT_TYPE_FAIL = "API_ADMIN_GET_DOCUMENT_TYPE_FAIL";

export const API_ADMIN_POST_DOCUMENT_TYPE = "API_ADMIN_POST_DOCUMENT_TYPE";
export const API_ADMIN_POST_DOCUMENT_TYPE_SUCCESS = "API_ADMIN_POST_DOCUMENT_TYPE_SUCCESS";
export const API_ADMIN_POST_DOCUMENT_TYPE_FAIL = "API_ADMIN_POST_DOCUMENT_TYPE_FAIL";

export const API_ADMIN_PATCH_DOCUMENT_TYPE = "API_ADMIN_PATCH_DOCUMENT_TYPE";
export const API_ADMIN_PATCH_DOCUMENT_TYPE_SUCCESS = "API_ADMIN_PATCH_DOCUMENT_TYPE_SUCCESS";
export const API_ADMIN_PATCH_DOCUMENT_TYPE_FAIL = "API_ADMIN_PATCH_DOCUMENT_TYPE_FAIL";

export const API_ADMIN_DELETE_DOCUMENT_TYPE = "API_ADMIN_DELETE_DOCUMENT_TYPE";
export const API_ADMIN_DELETE_DOCUMENT_TYPE_SUCCESS = "API_ADMIN_DELETE_DOCUMENT_TYPE_SUCCESS";
export const API_ADMIN_DELETE_DOCUMENT_TYPE_FAIL = "API_ADMIN_DELETE_DOCUMENT_TYPE_FAIL";

export const ADMIN_INIT_NEW_DOCUMENT_TYPE = "ADMIN_INIT_NEW_DOCUMENT_TYPE";

export const ADMIN_RESET_FOCUS_DOCUMENT_TYPE = "ADMIN_RESET_FOCUS_DOCUMENT_TYPE";
